import DefaultList from '../List';

export default class ConversionHistoryList extends DefaultList {
  list() {
    const { endpoint, parentEntity } = this.props;
    return endpoint.getHistory(parentEntity.entityId);
  }
}
